import { Modal } from "bootstrap"

export function showBootstrapConfirm(message) {
  return new Promise((resolve, reject) => {
    const template = document.getElementById("confirm-modal-template")
    if (!template) {
      reject(new Error("confirm-modal-template not found"))
      return
    }

    const modalId = `confirmModal-${crypto.randomUUID?.() ?? Date.now()}`
    const fragment = template.content.cloneNode(true)
    const modalElement = fragment.querySelector(".modal")
    modalElement.id = modalId

    const bodyEl = fragment.querySelector('[data-confirm-modal-part="body"]')
    if (bodyEl) bodyEl.textContent = message

    document.body.appendChild(fragment)

    const mounted = document.getElementById(modalId)
    const modal = new Modal(mounted)
    let confirmed = false
    let settled = false

    const settle = (value) => {
      if (settled) return
      settled = true
      resolve(value)
    }

    mounted.querySelector('[data-confirm-modal-part="confirm"]').addEventListener("click", () => {
      confirmed = true
      modal.hide()
      settle(true)
    }, { once: true })

    mounted.querySelector('[data-confirm-modal-part="cancel"]').addEventListener("click", () => {
      modal.hide()
    }, { once: true })

    mounted.addEventListener("hidden.bs.modal", () => {
      modal.dispose()
      mounted.remove()
      if (!confirmed) settle(false)
    }, { once: true })

    modal.show()
  })
}

export function installTurboConfirm() {
  if (!window.Turbo?.config?.forms) return

  // Fall back to the browser's native confirm if the Bootstrap modal
  // cannot be rendered (template missing or malformed), so a confirm
  // prompt never silently disappears and aborts the action.
  window.Turbo.config.forms.confirm = (message) =>
    showBootstrapConfirm(message).catch(() => window.confirm(message))
}
